import { render } from "./VueImageCropper.vue?vue&type=template&id=0b3579ba"
import script from "./VueImageCropper.vue?vue&type=script&lang=js"
export * from "./VueImageCropper.vue?vue&type=script&lang=js"

import "./VueImageCropper.vue?vue&type=style&index=0&id=0b3579ba&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__